const { endOfDay, startOfDay, format } = require('date-fns');
import timesheetbrApproveTemplate from './timesheetbrApprove.html';

angular
   .module('org.saga.widget.timesheetbrapprove', ['org.saga.service', 'org.saga.timesheetapprovecomment'])
   .directive('timesheetbrapproveWidget', [
      'PropertiesLoader',
      '$translate',
      'InstanceExpression',
      'TimesheetPM',
      'TimesheetDH',
      '$http',
      function (PropertiesLoader, $translate, InstanceExpression, TimesheetPM, TimesheetDH) {
         return {
            restrict: 'E',
            require: '^form',
            controllerAs: 'ctrl',
            template: timesheetbrApproveTemplate,
            scope: {
               widget: '=',
               editable: '=',
               instance: '=',
               required: '=',
               output: '=?'
            },
            link: function (scope, element, attrs, form) {
               scope.form = form;
            },
            controller: [
               '$scope',
               '$parse',
               '$mdDialog',
               'DefaultProperties',
               'TimesheetCommentDialog',
               function ($scope, $parse, $mdDialog, DefaultProperties, TimesheetCommentDialog) {
                  PropertiesLoader.load($scope, DefaultProperties.timesheetbrApprove);

                  function getService(mode) {
                     switch (mode) {
                        case 'pm':
                           return TimesheetPM;
                        case 'dh':
                           return TimesheetDH;
                        default:
                           throw new Error('Unknown timesheetbr-approve mode: ' + mode);
                     }
                  }

                  const Service = getService($scope.mode);

                  function getValueFromAttribute(attribute) {
                     if (typeof attribute === 'string') {
                        return InstanceExpression.eval(attribute, $scope.instance);
                     } else {
                        return attribute;
                     }
                  }

                  $scope.minDateObject = getValueFromAttribute($scope.minDate);
                  $scope.maxDateObject = getValueFromAttribute($scope.maxDate);

                  function formatDateTime(date) {
                     return format(date, "yyyy-MM-dd'T'HH:mm:ss.SSS");
                  }

                  function getRecords() {
                     const dateFrom = formatDateTime(startOfDay($scope.minDateObject));
                     const dateTo = formatDateTime(endOfDay($scope.maxDateObject));
                     const payload = {
                        timeFrom: dateFrom,
                        timeTo: dateTo
                     };

                     Service.find(payload)
                        .$promise.then(function (response) {
                           const sortedData = response.sort((a, b) => {
                              if (a.reporterEmail === null && b.reporterEmail !== null) return 1;
                              if (a.reporterEmail !== null && b.reporterEmail === null) return -1;
                              if (a.reporterEmail === null && b.reporterEmail === null) return 0;

                              const nameCompare = a.reporterEmail.localeCompare(b.reporterEmail);
                              if (nameCompare !== 0) return nameCompare;

                              const dateA = new Date(a.timeFrom);
                              const dateB = new Date(b.timeFrom);
                              return dateB - dateA; // Sort in descending order
                           });
                           $scope.output = angular.copy(sortedData);
                           $scope.reloadKey = Date.now(); // Force re-render of ng-repeat
                           setTotalMandays();
                        })
                        .catch(function (error) {
                           $scope.output = [];
                           setTotalMandays();
                        });
                  }

                  getRecords();

                  function setTotalMandays() {
                     $scope.totalManDays = $scope.output.reduce(
                        (acc, timesheet) => acc + timesheet.mandays,
                        0
                     );
                  }

                  $scope.selectedRecords = [];

                  $scope.toggleRecord = function (record) {
                     const index = $scope.selectedRecords.findIndex(
                        (selectedRecord) => selectedRecord.timesheetRowId === record.timesheetRowId
                     );
                     if (index !== -1) {
                        $scope.selectedRecords.splice(index, 1);
                     } else {
                        $scope.selectedRecords.push(record);
                     }
                  };

                  $scope.toggleAllRecords = function () {
                     if ($scope.selectedRecords.length === $scope.output.length) {
                        $scope.selectedRecords = [];
                     } else {
                        $scope.selectedRecords = angular.copy($scope.output);
                     }
                  };

                  $scope.existsInSelected = function (item) {
                     return (
                        $scope.selectedRecords.findIndex(
                           (selectedRecord) => selectedRecord.timesheetRowId === item.timesheetRowId
                        ) > -1
                     );
                  };

                  function createUploadData(records, decision, comment) {
                     const timesheetRows = records.map((record) => ({
                        timesheetRowId: record.timesheetRowId
                     }));
                     return {
                        timesheetRows: timesheetRows,
                        decision: decision,
                        comment: comment || ''
                     };
                  }

                  $scope.formatAndSave = function (records, decision, comment) {
                     const data = createUploadData(records, decision, comment);

                     Service.decision(data)
                        .$promise.then(function () {
                           getRecords();
                           $mdDialog.show(
                              $mdDialog
                                 .alert()
                                 .clickOutsideToClose(true)
                                 .title('Operace úspěšně dokončena')
                                 .textContent('All good')
                                 .ok($translate.instant('Ok'))
                           );
                        })
                        .catch(function (error) {
                           $mdDialog.show(
                              $mdDialog
                                 .alert()
                                 .clickOutsideToClose(true)
                                 .title($translate.instant('TimesheetSaveErrorTitle'))
                                 .textContent(
                                    $translate.instant('TimesheetSaveErrorMessage') +
                                       '\n' +
                                       error.data.message
                                 )
                                 .ok($translate.instant('Ok'))
                           );
                        });
                  };

                  function getDecision(record) {
                     switch ($scope.mode) {
                        case 'pm':
                           return record.projectManagerDecision;
                        case 'dh':
                           return record.departmentHeadDecision;
                        default:
                           return null;
                     }
                  }

                  $scope.approveRecord = function (record) {
                     $scope.approveSelected([record]);
                  };

                  $scope.approveSelected = function (records) {
                     $scope.formatAndSave(records, 'APPROVED', null);
                  };

                  $scope.denyRecord = function (record) {
                     TimesheetCommentDialog.show(record.comment, (comment) => {
                        $scope.formatAndSave([record], 'DENIED', comment);
                     });
                  };

                  $scope.changeComment = function (record) {
                     const decision = getDecision(record);
                     TimesheetCommentDialog.show(decision.comment, (newComment) => {
                        $scope.formatAndSave([record], decision.decision, newComment);
                     });
                  };

                  $scope.denySelected = function (records) {
                     TimesheetCommentDialog.show('', (comment) => {
                        $scope.formatAndSave(records, 'DENIED', comment);
                     });
                  };

                  $scope.getDotClass = function (value) {
                     if (value?.decision === 'APPROVED') return 'dot-green';
                     if (value?.decision === 'DENIED') return 'dot-red';
                     return 'dot-grey';
                  };

                  $scope.getDecisionClass = function (value) {
                     if (value?.decision === 'APPROVED') return 'decision-approved';
                     if (value?.decision === 'DENIED') return 'decision-denied';
                     return '';
                  }
               }
            ]
         };
      }
   ]);
